import * as angular from 'angular'; 
import { IRequestService } from '..';
import { DomainUserDto } from './DomainUserDto';

export interface IDomainSearchService {
    search(search: string): angular.IPromise<DomainUserDto[]>;
}

export class DomainSearchService implements IDomainSearchService {
    static serviceId = 'domainSearchService';
    static $inject = ['requestService'];

    private _controllerUrl = 'domainSearch';

    constructor(private _requestService: IRequestService) {
    }

    search(search: string): angular.IPromise<DomainUserDto[]> {
        const url = this._controllerUrl;
        const data = JSON.stringify(search);
        this._requestService.cleanCacheAtV1(url);
        return this._requestService.postAtV1(url, data);
    }
}